import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
import SchematicImg from "@/views/consult/components/SchematicImg.vue";
import util from "@/libs/util";
import { getApiBaseUrl } from "../../api/service";
export default {
  mixins: [userPopMixin],
  name: "capital-sign",
  components: {
    SchematicImg: SchematicImg
  },
  data: function data() {
    return {
      baseUrl: getApiBaseUrl(),
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        disputeCode: this.$route.query.disputeCode,
        contractCode: '',
        userName: '',
        userPhone: '',
        status: null
      },
      tableData: [{}],
      operationDescDialogVisible: false,
      operationForm: {
        operation: '',
        processCreds: []
      },
      disputeStatus: {
        '0': 0,
        '1': 0,
        '2': 0
      },
      operationLoading: false
    };
  },
  mounted: function mounted() {
    this.getDisputeStatus();
    this.getData();
  },
  methods: {
    resetSearch: function resetSearch() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 20,
        landlordName: '',
        landlordPhone: '',
        ustenantNameerName: '',
        tenantPhone: '',
        status: ''
      };
      this.getData('search');
    },
    getDisputeStatus: function getDisputeStatus() {
      var _this = this;
      this.$api.getDisputeStatus().then(function (res) {
        if (res.code == 200) {
          _this.disputeStatus = res.data;
        }
      });
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pageNum = 1;
              }
              _this2.tableLoading = true;
              _context.n = 1;
              return _this2.$api.getDisputeList(_this2.searchForm);
            case 1:
              res = _context.v;
              _this2.tableData = res.data.content;
              _this2.total = res.data.totalSize;
              _this2.tableLoading = false;
              _this2.tableData.forEach(function (item) {
                item.landlordId = item.landlord.id;
                item.tenantId = item.tenant.id;
              });
              _this2.getUserListByIds(_this2.tableData, "landlordId", "tenantId", "landlordInfo", "tenantInfo");
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    operationDescDialog: function operationDescDialog(row) {
      this.operationForm.operation = row.operation;
      this.operationForm.processCreds = row.processCreds;
      this.currentRow = row;
      this.operationDescDialogVisible = true;
    },
    // 认领
    disputeClaim: function disputeClaim(row) {
      var _this3 = this;
      console.log(util.cookies.get("uuid"));
      // debugger
      this.$api.disputeClaim({
        id: row.id,
        adminId: util.cookies.get("uuid")
      }).then(function (res) {
        if (res.code == 200) {
          var _row$tenant;
          _this3.$message.success("操作成功");
          _this3.getData();
          _this3.$operationLog.push({
            code: 'claim',
            userId: (row === null || row === void 0 || (_row$tenant = row.tenant) === null || _row$tenant === void 0 ? void 0 : _row$tenant.id) || '',
            houseId: (row === null || row === void 0 ? void 0 : row.houseId) || '',
            houseCode: (row === null || row === void 0 ? void 0 : row.houseCode) || '',
            operationType: 'contract_dispute',
            detailBatchNo: row.disputeCode
          });
        }
      });
    },
    // 标记已处理
    disputeProcessed: function disputeProcessed(row) {
      var _this4 = this;
      this.$api.disputeProcessed({
        id: row.id,
        adminId: util.cookies.get("uuid")
      }).then(function (res) {
        if (res.code == 200) {
          var _row$tenant2;
          _this4.$message.success("操作成功");
          _this4.getData();
          _this4.$operationLog.push({
            code: 'processed',
            userId: (row === null || row === void 0 || (_row$tenant2 = row.tenant) === null || _row$tenant2 === void 0 ? void 0 : _row$tenant2.id) || '',
            houseId: (row === null || row === void 0 ? void 0 : row.houseId) || '',
            houseCode: (row === null || row === void 0 ? void 0 : row.houseCode) || '',
            operationType: 'contract_dispute',
            detailBatchNo: row.disputeCode
          });
        }
      });
    },
    // 更新纠纷操作说明
    updateOperation: function updateOperation() {
      var _this5 = this;
      this.operationLoading = true;
      this.$api.updateOperation(_objectSpread(_objectSpread({}, this.operationForm), {}, {
        id: this.currentRow.id,
        adminId: util.cookies.get("uuid")
      })).then(function (res) {
        if (res.code == 200) {
          var _this5$currentRow, _this5$currentRow2, _this5$currentRow3;
          _this5.$message.success("操作成功");
          _this5.getData();
          _this5.operationDescDialogVisible = false;
          _this5.$operationLog.push({
            code: 'operation',
            userId: ((_this5$currentRow = _this5.currentRow) === null || _this5$currentRow === void 0 || (_this5$currentRow = _this5$currentRow.tenant) === null || _this5$currentRow === void 0 ? void 0 : _this5$currentRow.id) || '',
            houseId: ((_this5$currentRow2 = _this5.currentRow) === null || _this5$currentRow2 === void 0 ? void 0 : _this5$currentRow2.houseId) || '',
            houseCode: ((_this5$currentRow3 = _this5.currentRow) === null || _this5$currentRow3 === void 0 ? void 0 : _this5$currentRow3.houseCode) || '',
            operationType: 'contract_dispute',
            detailBatchNo: _this5.currentRow.disputeCode
          });
        }
        _this5.operationLoading = false;
      }).catch(function () {
        _this5.operationLoading = false;
      });
    }
  }
};